import { DateTime } from 'luxon';
import moment from 'moment';

export function usePrivacytoStringEn(detail, logo, width) {
    const personalDataCollection = detail?.personalDataCollection;
    const disclosurePersonalData = detail?.disclosurePersonalData;
    // const personalDataTopic = detail?.disclosurePersonalData?.personalDataTopic;
    const dataSubjectRightAndSecure = detail?.dataSubjectRightAndSecure;
    const marketingAdvertising = detail?.marketingAdvertising;
    const privacyPolicy = detail?.privacyPolicy;
    const dataController = detail?.dataController;
    const dpo = detail?.dpo;

    const date = moment(detail?.lastUpdate).format('DD-MM-YYYY');

    return {
        html: `
    <html>
    <head>
            <meta charset="UTF-8" />
            <title>Document</title>
            <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
            <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
        </head>
    <body style="word-break: break-word;">
    <center>
    ${
        logo &&
        `<img
        width=${width} height="100"
    style="object-fit: cover;"
    src=${logo}
    alt="logo "/>`
    }</center>
        <center><h3>Privacy Notice ${
            personalDataCollection?.companyNameEn || '-'
        }</h3></center>
         <p>
            &nbsp;&nbsp;&nbsp;&nbsp;${
                personalDataCollection?.companyNameEn || '-'
            } suggest our Subscriber to understand this
            Privacy Policy,We provide this privacy
            notice to inform our customers of our policy
            in relation to this policy is prescribed the
            process of data collect, store, use and
            disclose including other rights of
            Subscriber (“Data Subject”). Therefore,${
                personalDataCollection?.companyNameEn || '-'
            } would like to announce the Policy as
            followings:
        </p>

        ${
            disclosurePersonalData?.personalDataOptionSequence?.length !== 0 ||
            disclosurePersonalData?.sensitivePersonalDataOptionSequence
                ?.length !== 0
                ? `<h4>Personal Data</h4>
                <p>
                “Personal Data” means any information
                pertaining to a Data Subject, which
                enables the identification of Data
                Subject, whether direct or indirect.
                </p>
                <h4>Data collection</h4>
                <p>
                We collect, use or disclose your
                personal data followings:
                </p>
                <table
                    border="1"
                    style="width: 100%;
                    border-collapse: collapse;
                    border-style: hidden;
                    border-color: #f9f9f9;
                    background-color: #f9f9f9;
                    margin-bottom: 5px;
                    text-align: left;
                    padding: 1rem;
                    border-radius: 6;"
                >
                    <thead>
                        <tr>
                            <th
                                style="padding:1rem"
                            >
                            Type of Personal Data
                            </th>
                            <th
                            style="padding:1rem"
                            >
                            Personal Data
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        ${
                            disclosurePersonalData?.personalDataOptionSequence
                                ?.length !== 0
                                ? `<tr
                                style="border-top:1px solid #e9e9e9"
                            >
                                <td
                                    style="width:40%;padding-left:1.5rem"
                                >
                                Personal Data
                                </td>
                                <td>
                                    <ul
                                    style="padding-left:1.5rem;"
                                    >
                                        ${disclosurePersonalData?.personalDataOptionSequence
                                            ?.map(
                                                (option) =>
                                                    `<li>
                                                    ${
                                                        option.personDataOptionNameEn ||
                                                        option.personDataOptionNameTh
                                                    }
                                                </li>`
                                            )
                                            .join(' ')}
                                    </ul>
                                </td>
                            </tr>`
                                : ''
                        }
                        ${
                            disclosurePersonalData
                                ?.sensitivePersonalDataOptionSequence
                                ?.length !== 0
                                ? `<tr style="border-top:1px solid #e9e9e9">
                                    <td style="width:40%;padding-left:1.5rem">
                                    Sensitive Personal data
                                    </td>
                                    <td>
                                        <ul style="padding-left:1.5rem;">
                                            ${disclosurePersonalData?.sensitivePersonalDataOptionSequence
                                                ?.map(
                                                    (option) =>
                                                        `<li>
                                                        ${
                                                            option.sensitivePersonDataOptionNameEn ||
                                                            option.sensitivePersonDataOptionNameTh
                                                        }
                                                    </li>`
                                                )
                                                .join(' ')}
                                        </ul>
                                    </td>
                                </tr>`
                                : ''
                        }
                    </tbody>
                </table>`
                : ''
        }
 
            <h4>Sources of personal data</h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;We may get your personal data from the following
            channels:
        </p>
        ${
            personalDataCollection?.dataSourceFromDs
                ? `<h4>Collect personal data directly from you ("Data Subject")</h4> ${
                      personalDataCollection?.dataSourceFromDsEn || '-'
                  }`
                : ''
        }
        ${
            personalDataCollection?.dataSourceFromOther
                ? `<h4>Collect personal data from Other sources</h4> ${
                      personalDataCollection?.dataSourceFromOtherEn || '-'
                  } `
                : ''
        }
        <h4> Purpose of Collect,Use or disclose your personal data </h4>
        ${personalDataCollection?.purposeOfDataCollectionEn || '-'}
        <h4>Disclose personal data to others</h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;The company will not disclose your personal
            information to other individuals and juristic
            persons who are not affiliated companies of the
            company ("other people") unless it is disclosed
            to achieve the purpose of collecting and
            processing personal information as specified in
            this privacy notice. The company may disclose
            your personal information to other people such
            as
        </p>
        ${disclosurePersonalData?.discloseToOtherPersonEn || '-'}
        <h4>Retention period of personal data</h4>
        ${disclosurePersonalData?.retentionPeriodEn || '-'}
        <h4>International transfer of personal data</h4>
        ${disclosurePersonalData?.transferPersonalDataEn || '-'}
        <h4>Right of Data Subject</h4>
        <p>
            &nbsp;&nbsp;&nbsp;&nbsp;
            You can exercise your rights under the PDPA,details as specified below, through the channels prescribed by us:
        </p>
        <ul>
            <li>
            <h4>Right to withdraw consent</h4>
                ${dataSubjectRightAndSecure?.rightToWithdrawConsentEn || '-'}
            </li>
            <li>
            <h4>Right to access and obtain copy</h4>
                ${dataSubjectRightAndSecure?.rightOfAccessEn || '-'}
            </li>
            <li>
            <h4>Right to data portability</h4>
                ${dataSubjectRightAndSecure?.rightOfDataPortabilityEn || '-'}
            </li>
            <li>
            <h4>Right to object</h4>
                ${dataSubjectRightAndSecure?.rightToObjectEn || '-'}
            </li>
            <li>
            <h4>Right to restrict</h4>
                ${dataSubjectRightAndSecure?.rightToRestrictProcessingEn || '-'}
            </li>
            <li>
            <h4>Right to erasure</h4>
                ${dataSubjectRightAndSecure?.rightToErasureEn || '-'}
            </li>
            <li>
            <h4>Right to rectification</h4>
                ${dataSubjectRightAndSecure?.rightToRectificationEn || '-'}
            </li>
            ${
                dataSubjectRightAndSecure?.rightToComplaintEn
                    ? `<li>
                        <h4>Right to Complaint</h4>
                        ${dataSubjectRightAndSecure?.rightToComplaintEn || '-'}
                    </li>`
                    : ''
            }
        </ul>
        <h4>How security measures and quality of data</h4>
        ${dataSubjectRightAndSecure?.securityMeasureEn || '-'}
        <h4>
                                What are the marketing and promotional
                                activities
                            </h4>
        ${marketingAdvertising?.marketingActivityEn || '-'}
        <h4>
        What are the privacy policies of other websites
    </h4>
        ${privacyPolicy?.policyWebsiteEn || '-'}
        <h4>
        Please explain if the data subject denies giving
        you the necessary information for providing your
        services
    </h4>
        ${privacyPolicy?.undisclosedReasonEn || '-'}
        <h4>
        What are the actions, practices and policies
        regarding personal data
    </h4>
        ${privacyPolicy?.processPolicyEn || '-'}
        <h4>Data Protection Officer</h4>
        ${dpo?.dpoNameEn || '-'}
        <h4>Contact channel</h4>
        ${dataController?.contactChannelEn || '-'}
        <h4>Edition as of ${
            personalDataCollection?.effectiveDate
                ? DateTime.fromISO(
                      personalDataCollection?.effectiveDate
                  ).toLocaleString(DateTime.DATE_FULL)
                : '-'
        }</h4>
    <script type="text/javascript">
    $(document).ready(function() {
        let allElements = $('*');
        let converted = htmlDocx.asBlob(allElements.html());
        saveAs(converted, '${
            personalDataCollection?.privacyPolicyNoticeNameEn +
            `_${date}_EN.docx`
        }');
        setTimeout(()=> window.close(), 100)
        });
    </script>
    </body>
</html>`,
    };
}
